import { render } from "./addinvoice.vue?vue&type=template&id=5ac9f411&scoped=true"
import script from "./addinvoice.vue?vue&type=script&lang=js"
export * from "./addinvoice.vue?vue&type=script&lang=js"

import "./addinvoice.vue?vue&type=style&index=0&id=5ac9f411&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac9f411"]])

export default __exports__